module.exports = __webpack_public_path__ + "static/media/f_lipshape_largefull.95d6ed12.png";